import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import { getRooftopName } from 'selectors/appStatusSelectors'

import './index.scss'

export function Disclaimer({ rooftopName, className }) {
  return (
    <div className={c('frikin-disclaimer', className)}>
      By interacting with this site, I understand that I may be contacted by{' '}
      <strong>{rooftopName}</strong> via email, phone, and/or text message.
      Rates may apply. Payments require credit approval.{' '}
      <strong>Eligibility of incentives</strong>, and accuracy of{' '}
      <strong>trade payoff and allowance</strong> must be verified by the
      dealer. Programs subject to change.
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    rooftopName: getRooftopName(state),
  }
}

export default connect(mapStateToProps)(Disclaimer)
